import { render, staticRenderFns } from "./FeatureAnnouncements.vue?vue&type=template&id=150baff6"
import script from "./FeatureAnnouncements.vue?vue&type=script&lang=ts"
export * from "./FeatureAnnouncements.vue?vue&type=script&lang=ts"
import style0 from "./FeatureAnnouncements.vue?vue&type=style&index=0&id=150baff6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports